import React from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button, Modal, Row } from 'antd';
import {
  PlusOutlined,
  LockOutlined,
  SearchOutlined,
  SelectOutlined,
  SettingOutlined,
  UnlockOutlined,
} from '@ant-design/icons';
import moment from 'moment';
import { v4 as uuid } from 'uuid';

import { Label, SecondaryButton, SuccessButton, message } from 'components/common';
import {
  GreenColor,
  SmartBackButton,
  SmartBlock,
  SmartButton,
  SmartFormLabel,
  SmartNumberInput,
  SmartScanner,
  SmartScannerInput,
  SmartSpace,
  //SmartSpin,
  playSound,
} from 'components/Sales/Smart/SmartComponent';
import { PoRecvStorageKey } from 'constants/config';
import { receive } from 'services/purchaseOrder';
import { fetchWarehouseLocationList } from 'services/warehouse';
import { getStorage } from 'utils';
import CreateLotDrawer from './CreateLotDrawer';
import RecvConfirmDrawer from './RecvConfirmDrawer';
import RecvItemList from './RecvItemList';
import ScanQtySetting from './ScanQtySetting';
import SearchLotDrawer from './SearchLotDrawer';
import { DefaultScanRecvRatio, PoRecvActionType as PRAction, PoRecvStep, ScanRecvCountType, ScanRecvLotPolicy, ScanRecvRatioType } from './context';
import { getItemReceivingMaxQty, getMatchItemReceivingQty, isCodeMatchLine, isLotAvailableOnItem } from '.';

enum RecvStep {
  ScanLocation,
  ScanItem,
  ReceivedItem,
};

type Props = ReduxStateProps & {
  gotoAnchor?: Function;
};

const RecvPo = (props: Props) => {
  const { useState } = React;
  const [currentConfigVersion, setCurrentConfigVersion] = useState(0);
  const [currentItem, setCurrentItem] = useState<StringKAnyVPair>({});
  const [currentItemCode, setCurrentItemCode] = useState('');
  const [currentItemLocked, setCurrentItemLocked] = useState(true);
  const [currentItemRecvQty, setCurrentItemRecvQty] = useState<number>();
  const [currentLocation, setCurrentLocation] = useState<StringKAnyVPair>({});
  const [currentLotCode, setCurrentLotCode] = useState('');
  const [currentLotLocked, setCurrentLotLocked] = useState(true);
  const [currentStep, setCurrentStep] = useState<RecvStep>(RecvStep.ScanLocation);
  // eslint-disable-next-line
  const [focusOnLocation, setFocusOnLocation] = useState(1);
  const [inited, setInited] = useState(false);
  const [isCreateLotDrawerOpen, setIsCreateLotDrawerOpen] = useState(false);
  const [isRecvConfirmDrawerOpen, setIsRecvConfirmDrawerOpen] = useState(false);
  const [isSearchLotDrawerOpen, setIsSearchLotDrawerOpen] = useState(false);
  const [itemRecvInputVersion, setItemRecvInputVersion] = useState(0);
  const [itemScannerCode, setItemScannerCode] = useState('');
  const [itemScannerVersion, setItemScannerVersion] = useState(0);
  const [lastConfigVersion, setLastConfigVersion] = useState(0);
  const [lastRecvDirectlyVersion, setLastRecvDirectlyVersion] = useState(0);
  const [lastScanRecvVersion, setLastScanRecvVersion] = useState(0);
  const [lotScannerVersion, setLotScannerVersion] = useState(0);
  const [recvDirectlyVersion, setRecvDirectlyVersion] = useState(0);
  //const [recvItems, setRecvItems] = useState<StringKAnyVPair[]>([]);
  const [scanRecvVersion, setScanRecvVersion] = useState(0);
  const { t } = useTranslation();
  const history = useHistory();

  /*const recvCols = [
    {
      title: 'SKU',
      dataIndex: 'sku',
    },
    {
      title: 'UPC',
      dataIndex: 'upc',
    },
    {
      title: 'Location',
      dataIndex: 'receivingLocationCode',
    },
    {
      title: 'Receive Qty',
      dataIndex: 'receiveQty',
    },
  ];*/

  // eslint-disable-next-line
  const checkConfig = () => {
    const storage = getStorage('session');
    const scanRecvCountType = storage.getItem(PoRecvStorageKey.ScanRecvCountType);

    if (scanRecvCountType === null) {
      //openSetScanQtyDialog();
    }

    setDefaultItemRecvQty();
  };

  const closeConfirmReceivingItemsDrawer = () => {
    setIsRecvConfirmDrawerOpen(false);
  };

  const closeCreateLotDrawer = () => {
    setIsCreateLotDrawerOpen(false);
  };

  const closeSearchLotDrawer = () => {
    setIsSearchLotDrawerOpen(false);
  };

  const confirmItemsButton = () => {
    return (
      <SmartButton
        className="mb-0 mt-10"
        disabled={!isReceivingItemListSavable()}
        //onClick={saveReceivingItems}
        onClick={openConfirmReceivingItemsDrawer}
        size="large"
        type="primary"
      >
        Confirm
      </SmartButton>
    );
  };

  const currentItemLockClass = () => {
    const cls = ['fs-20', 'h-50', 'w-48', 'p-4-12'];

    if (currentItemLocked) {
      cls.push('default-btn-danger');
    }

    return cls.join(' ');
  };

  const currentLotLockClass = () => {
    const cls = ['fs-20', 'h-50', 'w-48', 'p-4-12'];

    if (currentLotLocked) {
      cls.push('default-btn-danger');
    }

    return cls.join(' ');
  };

  const findMatchItem = (
    itemCode: string,
    locationCode: string,
    lotCode = currentLotCode,
  ) => {
    props.state.recvItems.forEach((e: any) => console.log(isLotAvailableOnItem(props.state, e), e._receivingLot === lotCode, lotCode));
    return props.state.recvItems.find((e: StringKAnyVPair) => e.receivingLocationCode === locationCode && isCodeMatchLine(itemCode, e) && (isLotAvailableOnItem(props.state, e) ? e._receivingLot === lotCode : true));
  };

  const findMatchItemOrLine = (itemCode: string, locationCode: string, lotCode = currentLotCode) => {
    return findMatchItem(itemCode, locationCode, lotCode) || findMatchLine(itemCode);
  };

  const findMatchLine = (code: string) => {
    return props.state.poLines.find((l: StringKAnyVPair) => isCodeMatchLine(code, l));
  };

  const getDefaultItemRecvQty = (item: StringKAnyVPair) => {
    const { state } = props;
    let qty = (currentItemRecvQty || 1) * DefaultScanRecvRatio;

    if (state.scanRecvCountType === ScanRecvCountType.Custom) {
      if (state.scanRecvRatioType === ScanRecvRatioType.FixedRatio) {
        qty = 1 * state.scanRecvRatio;
      } else if (state.scanRecvRatioType === ScanRecvRatioType.Unreceived) {
        qty = getItemReceivingMaxQty(state.recvItems, item) - (item._receivingQty || 0);
      }
    }

    return qty;
  };

  const getMatchItemByCode = (itemCode: string, locationCode: string, lotCode = currentLotCode) => {
    const item = findMatchItemOrLine(itemCode, locationCode, lotCode);

    if (item) {
      if (isCurrentLocationSet() && !isItemInCurrentLocation(item)) {
        const ret: StringKAnyVPair = { ...item };

        ret._recvUuid = uuid();
        ret._receivingLot = '';
        ret._receivingQty = 0;
        ret.receivingLocationCode = currentLocation.locationCode;
        ret.receivingLocationNum = currentLocation.locationNum;
        delete ret.receivingQty;

        return ret;
      }
    }

    return item;
  };

  const gotoPrev = () => {
    if (props.state.recvItems.length > 0) {
      const { dispatch } = props;

      Modal.confirm({
        title: 'Confirm',
        content: 'Are you sure you want to go back? All data will be lost.',
        onOk() {
          dispatch({ type: PRAction.SetRecvItems, params: [] });
          history.goBack();
        },
      });
    } else {
      history.goBack();
    }
  };

  const handleLocationChange = async (str: string) => {
    const { dispatch, state } = props;
    const val = str.trim();

    if (val === '') return;

    playSound('bell');
    // location should be put into state in order to improve efficiency
    dispatch({ type: PRAction.SetLockScreen, params: true }); 
    try {
      //console.log('w', state.selectedWarehouse);
      const res = await fetchWarehouseLocationList(
        state.selectedWarehouse.warehouseId,
        false,
        val,
        0,
      );

      if (Array.isArray(res)) {
        if (res.length === 1) {
          console.log('location', res[0]);
          setCurrentLocation(res[0]);
          setCurrentStep(RecvStep.ScanItem);
        } else {
          playSound('error');
          if (res.length === 0) {
            message.error(`Not found location [${val}]`);
          } else {
            message.error(`Found ${res.length} location(s) for [${val}]`);
          }
        }
      } else {
        playSound('error');
        message.error(`Format error, not found location [${val}]`);
      }
    } catch(e) {
      playSound('error');
      message.error(`Fetched location information error: ${e}`);
    } finally {
      dispatch({ type: PRAction.SetLockScreen, params: false }); 
    }
  };

  const isCurrentLocationSet = () => {
    return currentLocation.locationNum > 0;
  };

  const isItemInCurrentLocation = (e: StringKAnyVPair) => {
    return isCurrentLocationSet()
        && e.receivingLocationCode === currentLocation.locationCode
        && e.receivingLocationNum === currentLocation.locationNum;
  };

  const isItemScanned = () => {
    return currentItem.poLineNum > 0;
  };

  const isItemSubmittable = (checkItem = false, checkLotCode = false) => {
    //let ret = currentStep === RecvStep.ScanItem && isItemScanned();
    let ret = currentStep === RecvStep.ScanItem;

    if (ret) {
      if (checkLotCode && isLotAvailableOnItem(props.state, currentItem)) ret = isLotScanned();
      if (ret && checkItem) ret = isItemScanned();
    }

    return ret;
  };

  const isLocationButtonEnable = () => {
    return currentStep === RecvStep.ScanItem && currentItemCode === '';
  };

  const isLotReleased = () => {
    return isLotScannable(true) ? !currentLotLocked : false;
  };

  const isLotScanned = () => {
    return !!currentLotCode.trim();
  };

  const isLotScannable = (checkItem = false) => {
    return currentStep === RecvStep.ScanItem && (checkItem ? (isItemScanned() && isLotAvailableOnItem(props.state, currentItem)) : props.state.enableLot);
    //return currentStep === RecvStep.ScanItem && isLotAvailableOnItem(props.state, currentItem);
  };

  const isReceivingItemListSavable = () => {
    return props.state.recvItems.length > 0 && currentItemCode === '';
  };

  const isPageRolledBack = () => {
    //return props.state.recvItems.length === 0 && !isItemSubmittable();
    //return props.state.recvItems.length === 0;
    return true;
  };

  const isQtyChangeable = (checkItem = false) => {
    return props.state.scanRecvCountType === ScanRecvCountType.Default ? (checkItem ? (isItemScanned() && !currentItemLocked) : !currentItemLocked) : false;
  };

  const onClearLotCode = () => {
    setCurrentLotCode('');
  };

  const onClearScannedItem = (checkLock = false) => {
    console.log('clear scanned item', checkLock);
    setCurrentItem({});
    setCurrentItemCode('');
    //setCurrentItemLocked(true);
    //setCurrentItemRecvQty(undefined);
    setDefaultItemRecvQty(checkLock);
    //if (!checkLock || (checkLock && !currentItemLocked)) setCurrentItemRecvQty(1);
    if (!checkLock || (checkLock && !currentLotLocked)) {
      setCurrentLotCode('');
      setLotScannerVersion(lotScannerVersion + 1);
    }

    setItemRecvInputVersion(itemRecvInputVersion + 1);
    setItemScannerCode('');
    setItemScannerVersion(itemScannerVersion + 1);
  };

  const onScanItem = (itemCode: string) => {
    const code = itemCode.trim();

    if (code !== currentItemCode) {
      const line = findMatchLine(code);
      //console.log('item', code);
      setCurrentItemCode(code);
      if (code !== itemCode) {
        setItemScannerCode(code);
      }

      if (line) {
        const item = getMatchItemByCode(code, currentLocation.locationCode);
        console.log('l', line, item);
        playSound('bell');
        setItemRecvInputVersion(itemRecvInputVersion + 1);

        if (item) {
          const rQty = getDefaultItemRecvQty(item);

          if (rQty === 0) {
            playSound('error');
            Modal.error({
              title: 'Error',
              content: `The required quantity of [${code}] has been received`,
              okButtonProps: {
                //size: 'large',
              },
              onOk() {
                setCurrentItemCode('');
                setItemScannerCode('');
                setItemScannerVersion(itemScannerVersion > 0 ? 0 : 1);
              },
            });
            return;
          }

          if (isLotAvailableOnItem(props.state, item)) {
            switch (props.state.scanRecvLotPolicy) {
              case ScanRecvLotPolicy.AssignSameLot:
                setCurrentLotCode(props.state.scanRecvLotUniNum);
                //setLotCodeOnFormItem(item, props.state.scanRecvLotUniNum);
                setLotScannerVersion(lotScannerVersion + 1);

                if (currentLotLocked && currentItemLocked) setRecvDirectlyVersion(recvDirectlyVersion + 1);
              break;

              case ScanRecvLotPolicy.InputManually:
                //console.log('hl', currentLotCode);
                if (currentLotLocked) {
                  if (isLotScanned()) submitRecvForm();
                  else setCurrentLotLocked(false);
                } else {
                  if (!currentLotLocked) {
                    setCurrentLotCode('');
                    setLotScannerVersion(lotScannerVersion + 1);
                  }
                }
              break;
            }
          } else {
            if (currentItemLocked) setRecvDirectlyVersion(recvDirectlyVersion + 1);
          }

          setCurrentItem(item);
          setCurrentItemRecvQty(rQty);

          if (props.state.scanRecvCountType === ScanRecvCountType.Custom && !isLotAvailableOnItem(props.state, item)) {
            setScanRecvVersion(scanRecvVersion + 1);
          }
        }
      } else {
        playSound('error');
        message.error({ content: `[${code}] not found` });
      }
    } else if (code !== itemScannerCode) {
      setItemScannerCode(code);
    }
  };

  const onScanLot = (lotStr: string) => {
    const lotCode = lotStr.trim();
    const item = getMatchItemByCode(currentItemCode, currentLocation.locationCode, lotCode);

    console.log('sl', item);
    if (item) {
      // note: the item is different from the item setted when scanning sku
      setCurrentItem(item);
      setCurrentItemRecvQty(getDefaultItemRecvQty(item));
      setLotCodeOnFormItem(item, lotCode);
      playSound('bell');

      //if (currentItemLocked) setRecvDirectlyVersion(recvDirectlyVersion + 1);
    } else {
      playSound('error');
      message.error({ content: `LOT#[${lotCode}] not found` });
    }
  };

  const onSelectLot = (lot: StringKAnyVPair) => {
    //console.log('lot', lot);
    onScanLot(lot.lotNumber);
    setLotScannerVersion(lotScannerVersion + 1);
  };

  const openConfirmReceivingItemsDrawer = () => {
    setIsRecvConfirmDrawerOpen(true);
  };

  const openCreateLotDrawer = () => {
    setIsCreateLotDrawerOpen(true);
  };

  const openSearchLotDrawer = () => {
    setIsSearchLotDrawerOpen(true);
  };

  const openSetScanQtyDialog = () => {
    const { state, dispatch } = props;
    let scanRecvCountType = state.scanRecvCountType;
    let scanRecvLotPolicy = state.scanRecvLotPolicy;
    let scanRecvLotUniNum = state.scanRecvLotUniNum;
    let scanRecvRatio = state.scanRecvRatio;
    let scanRecvRatioType = state.scanRecvRatioType;

    const onChangeScanRecvCountType = (ct: ScanRecvCountType) => {
      scanRecvCountType = ct;
      //console.log('sv', ct);
    };

    const onChangeScanRecvLotPolicy = (lp: ScanRecvLotPolicy) => {
      scanRecvLotPolicy = lp;
    };

    const onChangeScanRecvLotUniNum = (ln: string) => {
      scanRecvLotUniNum = ln;
    };

    const onChangeScanRecvRatio = (ratio: number) => {
      scanRecvRatio = ratio;
    };

    const onChangeScanRecvRatioType = (rt: ScanRecvRatioType) => {
      scanRecvRatioType = rt;
    };

    Modal.confirm({
      title: 'Scan Qty Setting',
      bodyStyle: {padding: '12px 12px'},
      icon: null,
      content: (
        <ScanQtySetting
          dispatch={dispatch}
          onChangeScanRecvCountType={onChangeScanRecvCountType}
          onChangeScanRecvLotPolicy={onChangeScanRecvLotPolicy}
          onChangeScanRecvLotUniNum={onChangeScanRecvLotUniNum}
          onChangeScanRecvRatio={onChangeScanRecvRatio}
          onChangeScanRecvRatioType={onChangeScanRecvRatioType}
          state={state}
        />
      ),
      onOk() {
        const storage = getStorage('session');

        dispatch({ type: PRAction.SetScanRecvCountType, params: scanRecvCountType });
        storage.setItem(PoRecvStorageKey.ScanRecvCountType, scanRecvCountType);
        dispatch({ type: PRAction.SetScanRecvLotPolicy, params: scanRecvLotPolicy });
        storage.setItem(PoRecvStorageKey.ScanRecvLotPolicy, scanRecvLotPolicy);
        dispatch({ type: PRAction.SetScanRecvLotUniNum, params: scanRecvLotUniNum });
        storage.setItem(PoRecvStorageKey.ScanRecvLotUniNum, scanRecvLotUniNum);
        dispatch({ type: PRAction.SetScanRecvRatio, params: scanRecvRatio });
        storage.setItem(PoRecvStorageKey.ScanRecvRatio, scanRecvRatio);
        dispatch({ type: PRAction.SetScanRecvRatioType, params: scanRecvRatioType });
        storage.setItem(PoRecvStorageKey.ScanRecvRatioType, scanRecvRatioType);

        if (scanRecvLotPolicy === ScanRecvLotPolicy.AssignSameLot) {
          setCurrentLotCode(scanRecvLotUniNum);
          setLotScannerVersion(lotScannerVersion + 1);
        } else {
          if (scanRecvLotUniNum === currentLotCode) {
            setCurrentLotCode('');
            setLotScannerVersion(lotScannerVersion + 1);
          }
        }

        setCurrentConfigVersion(currentConfigVersion + 1);
        setTimeout(() => {
          // must use timeout here
          setItemRecvInputVersion(itemRecvInputVersion + 1);
        }, 0);
      },
    });
  };

  // eslint-disable-next-line
  const receiveItem = () => {
    const { dispatch, state } = props;
    const item = findMatchItem(currentItemCode, currentLocation.locationCode);
    const line = findMatchLine(currentItemCode);
    const nQty = getMatchItemReceivingQty(state.recvItems, currentItemCode);
    // check whether the Qty is invaild
    if (state.enablePOReceiveControl) {
      const maxQty = Math.round(line.poQty * (1 + state.poOverRecvPercent));

      if (nQty + (currentItemRecvQty || 0) + line.humanReceiveQty > maxQty) {
        playSound('error');
        Modal.error({
          title: 'Error',
          content: `Cannot exceed total quatity[${maxQty}]`,
          okButtonProps: {
            //size: 'large',
          },
        });
        return;
      }
    }

    if (item) {
      //console.log('item', item, currentItemRecvQty);
      //currentItem._receivingQty = currentItem._receivingQty + currentItemRecvQty;
      item._receivingQty = item._receivingQty + currentItemRecvQty;
      //setRecvItems([...recvItems]);
      dispatch({ type: PRAction.SetRecvItems, params: [...state.recvItems] });
    } else {
      currentItem._receivingLot = currentLotCode;
      currentItem._receivingQty = currentItemRecvQty;
      //setRecvItems([currentItem, ...recvItems]);
      dispatch({ type: PRAction.SetRecvItems, params: [currentItem, ...state.recvItems] });
    }

    if (line) {
      const qty = getMatchItemReceivingQty(state.recvItems, currentItemCode);

      //console.log('rqty', qty);
      line.receivingQty = qty + (currentItemRecvQty || 0);
      dispatch({ type: PRAction.SetPoLines, params: [...state.poLines] });
    }

    playSound('success');
    onClearScannedItem(true);
  };

  const receiveNextItemInAnotherLocation = () => {
    const { dispatch } = props;

    onClearScannedItem();
    setCurrentLocation({});
    //setRecvItems([]);
    dispatch({ type: PRAction.SetRecvItems, params: [] });
    setCurrentStep(RecvStep.ScanLocation);
  };

  const receiveNextItemInCurrentLocation = () => {
    const { dispatch } = props;

    onClearScannedItem();
    //setRecvItems([]);
    dispatch({ type: PRAction.SetRecvItems, params: [] });
    setCurrentStep(RecvStep.ScanItem);
  };

  const receiveNextPO = () => {
    if (props.gotoAnchor) {
      props.dispatch({ type: PRAction.SetPoLines, params: [] });
      props.dispatch({ type: PRAction.SetPoList, params: [] });
      props.dispatch({ type: PRAction.SetRecvItems, params: [] });
      props.gotoAnchor(PoRecvStep.ScanPo);
    }
  };

  const receiveNextStepWizard = () => {
    return (<>
      <SmartButton
        className="mb-0 mt-10"
        //disabled={!isReceivingItemListSavable()}
        onClick={receiveNextItemInCurrentLocation}
        size="large"
        type="primary"
      >
        Continue in Current Location
      </SmartButton>
      <SmartButton
        className="mb-0 mt-10"
        //disabled={!isReceivingItemListSavable()}
        onClick={receiveNextItemInAnotherLocation}
        size="large"
        type="primary"
      >
        Receive to Another Location
      </SmartButton>
      {props.gotoAnchor && <SmartButton
        className="mb-0 mt-10"
        //disabled={!isReceivingItemListSavable()}
        onClick={receiveNextPO}
        size="large"
        type="primary"
      >
        Receive Another PO
      </SmartButton>}
    </>);
  };

  const saveReceivingItems = async () => {
    const { dispatch, state } = props;

    console.log(state);
    dispatch({ type: PRAction.SetLockScreen, params: true }); 
    try {
      const res = await receive(state.currentPo.fulfillmentPoId, {
        WarehouseNum: state.selectedWarehouse.warehouseNum,
        Items: state.recvItems.map((e: StringKAnyVPair) => ({
          SKU: e.sku,
          FulfillmentPoLineNum: e.fulfillmentPoLineNum,
          //ReceiveQty: e.humanReceiveQty + e._receivingQty,
          ReceiveQty: e._receivingQty,
          LocationNum: e.receivingLocationNum,
          LotNumber: isLotAvailableOnItem(state, e) ? e._receivingLot : undefined,
          //ReceiptDate: moment(receiptDate).format('YYYY-MM-DD'),
          ReceiptDate: moment().format('YYYY-MM-DD'),
        })),
      });
      if (res) {
        setCurrentStep(RecvStep.ReceivedItem);
      }
    } catch(e) {
      message.error(`Received error: ${e}`);
    } finally {
      dispatch({ type: PRAction.SetLockScreen, params: false }); 
    }
  };

  // eslint-disable-next-line
  const setDefaultItemRecvQty = (checkLock = false) => {
    const { state } = props;
    let qty: any = currentItemRecvQty;

    if (state.scanRecvCountType === ScanRecvCountType.Custom) {
      if (state.scanRecvRatioType === ScanRecvRatioType.FixedRatio) {
        qty = 1 * state.scanRecvRatio;
      } else if (state.scanRecvRatioType === ScanRecvRatioType.Unreceived) {
        //qty = getItemReceivingMaxQty(state.recvItems, item) - (item._receivingQty || 0);
        qty = undefined;
      }
    } else {
      if (!checkLock || (checkLock && !currentItemLocked)) {
        qty= 1 * DefaultScanRecvRatio;
      }
    }
    //console.log(' -> ', state.scanRecvCountType === ScanRecvCountType.Custom, qty);

    setCurrentItemRecvQty(qty);
  };

  const searchLotButton = () => {
    return (
      <Button
        disabled={!isLotReleased()}
        onClick={openSearchLotDrawer}
        type="text"
      >
        <SearchOutlined />
      </Button>
    );
  };

  const setLotCodeOnFormItem = (item: StringKAnyVPair, lotCode: string) => {
    item._receivingLot = lotCode;
    setCurrentLotCode(lotCode);
  };

  const submitItemButton = () => {
    return (
      <SmartButton
        className="mb-0"
        disabled={!isItemSubmittable(true, true)}
        onClick={receiveItem}
        size="large"
        type="primary"
      >
        Submit
      </SmartButton>
    );
  };

  const submitRecvForm = () => {
    setRecvDirectlyVersion(recvDirectlyVersion + 1);
  };

  const switchLocation = () => {
    setCurrentLocation({});
    setCurrentStep(RecvStep.ScanLocation);
  };

  const toggleCurrentItemLockState = () => {
    setCurrentItemLocked(!currentItemLocked);
  };

  const toggleCurrentLotLockState = () => {
    setCurrentLotLocked(!currentLotLocked);
  };

  const usePoQtyAsCurrentItemRecvQty = () => {
    const line = findMatchLine(currentItemCode);

    if (line) {
      const nQty = getMatchItemReceivingQty(props.state.recvItems, currentItemCode);
      const rQty = line.poQty - line.humanReceiveQty - nQty;
      //console.log('rqty', line, nQty, rQty);
      setCurrentItemRecvQty(rQty);
      setItemRecvInputVersion(itemRecvInputVersion + 1);
    }
  };

  const updateCurrentItemRecvQty = (
    qty: any,
    updateInput?: boolean,
  ) => {
    if (typeof qty === 'number') {
      const { state } = props;

      if (state.enablePOReceiveControl) {
        const line = findMatchLine(currentItemCode);
        const nQty = getMatchItemReceivingQty(props.state.recvItems, currentItemCode);
        const maxQty = Math.round(line.poQty * (1 + state.poOverRecvPercent));

        if (nQty + qty + line.humanReceiveQty > maxQty) {
          playSound('error');
          Modal.error({
            title: 'Error',
            content: `Cannot exceed total quatity[${maxQty}]`,
            onOk() {
              setCurrentItemRecvQty(currentItemRecvQty);
              setItemRecvInputVersion(itemRecvInputVersion + 1);
            },
          });
        } else {
          setCurrentItemRecvQty(qty);
        }
      } else {
        setCurrentItemRecvQty(qty);
      }
    }

    if (updateInput) setItemRecvInputVersion(itemRecvInputVersion + 1);
  };

  React.useEffect(() => {
    let itemReceived = false;

    if (!inited) {
      checkConfig();
      setInited(true);
    }

    if (currentConfigVersion !== lastConfigVersion) {
      setDefaultItemRecvQty();
      setLastConfigVersion(currentConfigVersion);
    }

    if (scanRecvVersion !== lastScanRecvVersion) {
      console.log('sv', itemReceived, scanRecvVersion);
      receiveItem();
      itemReceived = true;
      setLastScanRecvVersion(scanRecvVersion);
      setTimeout(() => {
        // note: two jumps are needed for safety because of adding 1 in the clear function
        setItemScannerVersion(itemScannerVersion + 2);
      }, 500);
    }

    if (recvDirectlyVersion !== lastRecvDirectlyVersion) {
      console.log('dv', itemReceived, recvDirectlyVersion);
      if (!itemReceived) {
        receiveItem();
        itemReceived = true;
      }

      setLastRecvDirectlyVersion(recvDirectlyVersion);
    }
  }, [
    checkConfig,
    currentConfigVersion,
    inited,
    itemScannerVersion,
    lastConfigVersion,
    lastRecvDirectlyVersion,
    lastScanRecvVersion,
    receiveItem,
    recvDirectlyVersion,
    scanRecvVersion,
    setDefaultItemRecvQty,
  ]);

  return (<>
    <SmartSpace className="ant-card ant-card-bordered mb-5">
      <div className="ant-card-body card-body-p10">
        <Row  align="middle" justify="space-between">
          <span>
            <Label className="tail-colon2" theme={{fontSize: '1.2em'}}>PO#</Label>
            <Label className="label-grey" theme={{fontSize: '1.2em'}}>{props.state.currentPo.poNumber || ''}</Label>
          </span>
          <SecondaryButton
            className="icon-btn-small"
            onClick={openSetScanQtyDialog}
          >
            <SettingOutlined />
          </SecondaryButton>
        </Row>
        {isCurrentLocationSet() && (
          <Row className="mt-10" align="middle" justify="space-between">
            <span>
              <Label className="tail-colon2" theme={{fontSize: '1.2em'}}>Location</Label>
              <Label className="label-grey" theme={{fontSize: '1.2em'}}>{currentLocation.locationCode}</Label>
            </span>
            <SuccessButton
              className="icon-btn-small"
              disabled={!isLocationButtonEnable()}
              onClick={switchLocation}
              size="small"
              type="primary"
            >
              <SelectOutlined />
            </SuccessButton>
          </Row>
        )}
      </div>
    </SmartSpace>
    <SmartSpace className="mb-5">
      {currentStep !== RecvStep.ReceivedItem && <SmartFormLabel
        style={{ color: GreenColor, fontWeight: 600, fontSize: 18 }}
      >
        {currentStep === RecvStep.ScanLocation ? t("smart.poreceive.scanLocation") : 'Scan Item'}
      </SmartFormLabel>}
      {currentStep === RecvStep.ScanLocation && (
        <SmartScanner
          className="mt-2 mb-5"
          //disabled={isFetching}
          isAutoFocus={focusOnLocation}
          placeholder="Input location here"
          onChangeValue={handleLocationChange}
        />
      )}
      {currentStep === RecvStep.ScanItem && (
        <SmartScannerInput
          allowClear
          autoFocus
          className="fs-24 mt-2 mb-5 h-50"
          placeholder="Input item here"
          onClear={onClearScannedItem}
          onScan={onScanItem}
          updateValue={itemScannerCode}
          version={itemScannerVersion}
        />
      )}
      {isLotScannable() && (<>
        <SmartFormLabel
          style={{ color: GreenColor, fontWeight: 600, fontSize: 18 }}
        >
          LOT#
        </SmartFormLabel>
        <Row className="mt-5" justify="space-between">
          <SmartScannerInput
            addonAfter={searchLotButton()}
            allowClear
            className="fs-24 h-50"
            defaultValue={currentLotCode}
            disabled={!isLotReleased()}
            onClear={onClearLotCode}
            onScan={onScanLot}
            placeholder="Input LOT# here"
            style={{width: 'calc(100% - 120px)'}}
            version={lotScannerVersion}
          />
          <SuccessButton
            className="fs-22 h-50 p-4-13"
            disabled={!isLotReleased()}
            onClick={openCreateLotDrawer}
          >
            <PlusOutlined />
          </SuccessButton>
          <Button
            className={currentLotLockClass()}
            onClick={toggleCurrentLotLockState}
          >
            {currentLotLocked ? <LockOutlined /> : <UnlockOutlined />}
          </Button>
        </Row>
      </>)}
      {isItemSubmittable() && (<>
        <SmartFormLabel
          style={{ color: GreenColor, fontWeight: 600, fontSize: 18 }}
        >
          Qty
        </SmartFormLabel>
        <Row className="mt-5" justify="space-between">
          <SmartNumberInput
            className="num-input h-50"
            disabled={!isQtyChangeable()}
            key={`recv-input${itemRecvInputVersion}`}
            onChange={updateCurrentItemRecvQty}
            style={{width: 'calc(100% - 173px)'}}
            value={currentItemRecvQty}
          />
          <Button
            className="fs-16 h-50 p-4-8"
            disabled={!isQtyChangeable(true)}
            onClick={usePoQtyAsCurrentItemRecvQty}
          >
            Use PO Qty
          </Button>
          <Button
            className={currentItemLockClass()}
            onClick={toggleCurrentItemLockState}
          >
            {currentItemLocked ? <LockOutlined /> : <UnlockOutlined />}
          </Button>
        </Row>
        <SmartBlock className="mt-15">{submitItemButton()}</SmartBlock>
      </>)}
      {currentStep === RecvStep.ReceivedItem && (<>
        <Row className="mt-5">
          <Label theme={{fontSize: '1.3em'}}>Received Successfully!</Label>
        </Row>
        {receiveNextStepWizard()}
      </>)}
      {props.state.recvItems.length > 0 && (<>
        <Row className="mt-5">
          <Label theme={{fontSize: '1.3em'}}>{`${currentStep === RecvStep.ScanItem ? 'Receiving' : 'Received'}`} Lines</Label>
        </Row>
        {/*renderReceivingItems(props.state.recvItems)*/}
        <RecvItemList
          dispatch={props.dispatch}
          editable={currentStep === RecvStep.ScanItem}
          state={props.state}
        />
        {currentStep === RecvStep.ScanItem && confirmItemsButton()}
      </>)}
    </SmartSpace>
    {isPageRolledBack() && <SmartSpace>
      <SmartBackButton
        //onClick={() => history.goBack()}
        onClick={gotoPrev}
      />
    </SmartSpace>}
    {isRecvConfirmDrawerOpen && (
      <RecvConfirmDrawer
        dispatch={props.dispatch}
        onClose={closeConfirmReceivingItemsDrawer}
        onSave={saveReceivingItems}
        state={props.state}
        visible={isRecvConfirmDrawerOpen}
      />
    )}
    {isCreateLotDrawerOpen && (
      <CreateLotDrawer
        dispatch={props.dispatch}
        items={[currentItem]}
        onClose={closeCreateLotDrawer}
        onSave={onSelectLot}
        state={props.state}
        visible={isCreateLotDrawerOpen}
      />
    )}
    {isSearchLotDrawerOpen && (
      <SearchLotDrawer
        dispatch={props.dispatch}
        onClose={closeSearchLotDrawer}
        onSelect={onSelectLot}
        state={props.state}
        sku={currentItem.sku}
        visible={isSearchLotDrawerOpen}
      />
    )}
  </>);
};

export default RecvPo;
